/* ============================================================
   MOONRISE — Cart store + event bus
   Pattern borrowed from Dawn (PUB_SUB + subscribe + publish).
   Single source of cart truth in the browser. Re-fetches from
   /cart.js after mutations to stay authoritative.
   ============================================================ */

(function () {
  'use strict';

  if (window.Moonrise && window.Moonrise.cart) return;

  var subscribers = {};

  function subscribe(eventName, callback) {
    if (!subscribers[eventName]) subscribers[eventName] = [];
    subscribers[eventName].push(callback);
    return function unsubscribe() {
      var list = subscribers[eventName];
      if (!list) return;
      subscribers[eventName] = list.filter(function (fn) { return fn !== callback; });
    };
  }

  function publish(eventName, payload) {
    var list = subscribers[eventName];
    if (!list) return;
    list.forEach(function (fn) {
      try { fn(payload); } catch (e) { /* keep going */ }
    });
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function addItem(id, quantity, properties) {
    var body = { items: [{ id: id, quantity: quantity || 1 }] };
    if (properties) body.items[0].properties = properties;
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { return Promise.reject(err); });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function (cart) { publish('cart:updated', cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        /* Errors (e.g. 422 "only N in stock") reject with Shopify's message
           instead of being published as if they were the cart. */
        if (!r.ok) {
          return r.json().then(
            function (err) { return Promise.reject(err); },
            function () { return Promise.reject({ status: r.status }); }
          );
        }
        return r.json();
      })
      .then(function (cart) { publish('cart:updated', cart); return cart; });
  }

  function clear() {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { publish('cart:updated', cart); return cart; });
  }

  /* ---------- Sections API: fetch a section's HTML and swap it in ---------- */
  function sectionRender(sectionId, sectionSelector) {
    var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + '?section_id=' + sectionId;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var selector = sectionSelector || '[data-section-id="' + sectionId + '"]';
        return doc.querySelector(selector) ? doc.querySelector(selector).outerHTML : html;
      });
  }

  window.Moonrise = window.Moonrise || {};
  window.Moonrise.cart = {
    fetch: fetchCart,
    add: addItem,
    change: changeLine,
    clear: clear,
    subscribe: subscribe,
    publish: publish,
    sectionRender: sectionRender
  };
})();
